'use strict';

import Vue from 'vue';
import { logger } from '@/logging';


export const fetchOwnLikes = async ({ dispatch }, userID) => {
	return await dispatch('find', { query: { user: userID }});
};

//=================================================================================================================

export const fetchByActionID = async ({ dispatch }, actionID) => {
	return await dispatch('find', { query: { action: actionID }});
};

//=================================================================================================================

export const likeAction = async (context, actionID) => {
	const { Like } = Vue.$FeathersVuex;
	const like = new Like({});

	try {
		return await like.save({ query: { action: actionID }});
	}
	catch(err) {
		logger.get('likes').error('Error when saving like', err);
		throw err;
	}
};

//=================================================================================================================

export const unlikeAction = async (context, actionID) => {
	const { Like } = Vue.$FeathersVuex;
	const like = new Like({ id: null });

	try {
		return await like.remove({ query: { action: actionID }});
	}
	catch(err) {
		logger.get('likes').error('Error when deleting like', err);
		throw err;
	}
};
